(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["afr-search-suggestions"] && !Shopify.designMode) return;
  try {
    (() => {
  const key = 'afr-search-terms';
  function readTerms() {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value.filter(term => typeof term === 'string' && term.length <= 100).slice(0, 6) : [];
    } catch { return []; }
  }
  function renderTerms() {
    const terms = readTerms();
    document.querySelectorAll('[data-afr-search-recents]').forEach(panel => {
      const list = panel.querySelector('ul');
      list.replaceChildren();
      terms.forEach(term => {
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.href = panel.dataset.searchUrl + '?q=' + encodeURIComponent(term) + '&type=product';
        link.textContent = term;
        li.append(link);
        list.append(li);
      });
      panel.hidden = !terms.length;
    });
  }
  document.addEventListener('focusin', event => {
    if (event.target.matches('#x-header .input-search')) renderTerms();
  });
  document.addEventListener('submit', event => {
    if (!event.target.closest('.afr-search-focus')) return;
    const term = event.target.querySelector('.input-search')?.value.trim().slice(0, 100);
    if (!term) return;
    try { localStorage.setItem(key, JSON.stringify([term, ...readTerms().filter(value => value !== term)].slice(0, 6))); } catch {}
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-afr-search-clear]')) return;
    try { localStorage.removeItem(key); } catch {}
    renderTerms();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
